import { TEntityOverride, TEntityOverrideProp } from '../types/index'

type TProps<T extends Record<PropertyKey, unknown>> = {
  entity: TEntityOverride
  render: (props: {
    propertyKey: string
    property: TEntityOverrideProp
    entity: TEntityOverride
    index: number
    childProps: T
  }) => JSX.Element
  childProps: T
}

const EntityPropertiesList = <T extends Record<PropertyKey, unknown>>({
  entity,
  render,
  childProps,
}: TProps<T>): JSX.Element[] => {
  const propertiesWithExtra = {
    ...entity.properties,
    ...entity.extraProperties,
  }
  const order = entity?.order ?? []
  const unorderedPropertyKeys = Object.keys(propertiesWithExtra).filter(
    propertyKey => !order.includes(propertyKey),
  )
  const orderedPropertyKeys = [...order, ...unorderedPropertyKeys]
  const orderedProperties = orderedPropertyKeys.map((propertyKey, index) => {
    const property = propertiesWithExtra?.[propertyKey]
    if (property === undefined) {
      throw new Error(
        `InvalidEntityPropertyKey: Entity doesn't have property key "${propertyKey}", specified in entity.order[${index}]. Possible values are: ${Object.keys(
          propertiesWithExtra,
        ).join(',')}`,
      )
    }
    return [propertyKey, property] as const
  })

  return orderedProperties
    .filter(([_, property]) => property.hidden !== true)
    .map(([propertyKey, property], index) => {
      return render({
        propertyKey,
        property,
        entity,
        index,
        childProps,
      })
    })
}

export default EntityPropertiesList
